(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["korge-fleks-hello-world"] = factory();
	else
		root["korge-fleks-hello-world"] = factory();
})(globalThis, () => {
return 